/**
 * List all your global JS packages here
 */

import 'bootstrap/dist/js/bootstrap';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/vendor.ts